import React from "react";
import { gql, useQuery } from "@apollo/client";
import { Select } from "@shopify/polaris";

const MERCHANT_BRAND_LIST = gql`
  query merchantBrandList($status: Int = 1) {
    merchantBrandList(status: $status) {
      id
      alias
      name
      banner
      picture
      description
      status
    }
  }
`;

interface Props {
  value: string;
  onChange: (v: string) => void;
  polaris?: boolean;
}

export function ProductDraftBrandPicker(props: Props) {
  const { data } = useQuery(MERCHANT_BRAND_LIST);

  if (!data || !data.merchantBrandList)
    return (
      <select className="form-control">
        <option>Loading...</option>
      </select>
    );

  const brands = [
    {
      label: "No Brand",
      value: "0",
    },
    ...data.merchantBrandList.map((x: any, i: number) => {
      return {
        label: x.name,
        value: String(x.id),
      };
    }),
  ]

  if (props.polaris) {
    return (
      <Select
        label="Brand"
        value={String(props.value)}
        onChange={(e) => props.onChange(e)}
        options={brands}
      />
    );
  }

  return (
    <select className="form-control" value={props.value} onChange={(e) => props.onChange(e.target.value)}>
      <option value={0}>No Brand</option>
      {data.merchantBrandList.length > 0 &&
        data.merchantBrandList.map((x: any, i: number) => {
          return (
            <option value={x.id} key={i}>
              {x.name}
            </option>
          );
        })}
    </select>
  );
}
